export class PositionNotFountError extends Error {
  constructor() {
    super("Posição não encontrada");
    this.name = "PositionNotFountError";
  }
}
